// Backend URL for serving uploads
export const BACKEND_URL = 'https://systems.esdfl.net';

export function getImageUrl(path: string | undefined | null): string | undefined {
  if (!path) return undefined;
  // If already absolute URL, return as-is (for backwards compatibility)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Prepend backend URL for relative paths
  return `${BACKEND_URL}${path}`;
}

